<div class="page-cont col-12">
  <div class="title-cont">
    <h4 class="title-h4-blue">{{ title }}</h4>
    <div class="exportar-cont">
      <app-exportar
        [data]="insuranceData"
        (exportar)="onExportar($event)"
      ></app-exportar>
    </div>
  </div>
  <hr />
  <div class="campos-cont">
    <app-campos
      [tipo]="'cobros'"
      [camposVisibles]="['desde', 'hasta', 'ramo', 'subramo', 'selectFilter']"
      [camposObligatorios]="['desde', 'hasta']"
      [sLobName]="getSlobName()"
      [lobName]="getLobName()"
      (filterChange)="onFilterChange($event)"
      [opcionesSelectFilter]="opcionesSelectFilter"
    ></app-campos>
  </div>
</div>

<app-insurance-table
  [data]="insuranceData"
  [itemsPerPage]="6"
  [config]="tableConfig"
  [configExport]="tableConfigExport || tableConfig"
  [mensajeNoData]="mensajeNoData"
  [error]="errorStatus"
  (actionClick)="onPrintInvoice($event)"
></app-insurance-table>
